import Model, { attr, belongsTo } from '@ember-data/model';
import type CompanyModel from './company.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class PartnerPolicyModel extends Model {
  // These are markdown-formatted strings returned from the API
  @attr declare policies: string;
  @attr declare programs: string;
  @attr declare programMap: string;

  @attr declare versionRef: string;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  @belongsTo('company', { async: false, inverse: null })
  declare company: CompanyModel;

  [Type] = 'partner-policy' as const;
}
